document.querySelectorAll(".product--thumbnail_left").forEach((product) => {
  const list = product.querySelector(".thumbnail-list");
  if (!list) return;

  const thumbSlider = product.querySelector(".thumbnail-slider");
  if (!thumbSlider) return;

  thumbSlider.isSlideVisible = () => false;

  const prevBtn = thumbSlider.querySelector('.slider-button[name="previous"]');
  const nextBtn = thumbSlider.querySelector('.slider-button[name="next"]');

  prevBtn?.removeAttribute("disabled");
  nextBtn?.removeAttribute("disabled");

  const viewer = product.querySelector('[id^="GalleryViewer"]');
  const desktopMq = window.matchMedia("(min-width: 750px)");
  const wideDesktopMq = window.matchMedia("(min-width: 990px)");

  const getVisibleThumbs = () => (wideDesktopMq.matches ? 6 : 5);

  const syncHeight = () => {
    if (!viewer) return;

    if (!desktopMq.matches) {
      product.style.removeProperty("--xts-thumb-size");
      list.style.removeProperty("max-height");
      return;
    }

    const btnHeight =
      (prevBtn?.offsetHeight || 0) + (nextBtn?.offsetHeight || 0);
    const viewerHeight = viewer.offsetHeight;
    const gap = parseFloat(getComputedStyle(list).gap) || 0;
    const visibleThumbs = getVisibleThumbs();
    const thumbSize = Math.floor(
      (viewerHeight - btnHeight - (visibleThumbs - 1) * gap) / visibleThumbs,
    );

    if (thumbSize <= 0) return;

    product.style.setProperty("--xts-thumb-size", thumbSize + "px");
    list.style.maxHeight = viewerHeight - btnHeight + "px";
  };

  syncHeight();
  window.addEventListener("resize", syncHeight);

  const getItemHeight = () => {
    const item = list.querySelector(".thumbnail-list__item");
    if (!item) return 0;
    const gap = parseFloat(getComputedStyle(list).gap) || 0;
    return item.offsetHeight + gap;
  };

  thumbSlider.addEventListener(
    "click",
    (e) => {
      const btn = e.target.closest(".slider-button");
      if (!btn) return;
      if (!desktopMq.matches) return;
      e.stopImmediatePropagation();
      if (btn.name === "previous") {
        list.scrollBy({ top: -getItemHeight(), behavior: "smooth" });
      } else if (btn.name === "next") {
        list.scrollBy({ top: getItemHeight(), behavior: "smooth" });
      }
    },
    { capture: true },
  );
});
